import { ProspectoCab } from './../../../models/ProspectoCab';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from 'app/dashboard/dashboard.component';
import Swal from 'sweetalert2';
import { ProspectosService } from 'app/services/operaciones/prospectos/prospectos.service';
import { MessagesTitles, MessagesGeneral, MessagesDates, MessagesStatus } from 'app/models/messages';
import { ObservacionesRespuestaFormat } from 'app/models/ObservacionesRespuestaFormat';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { FiltrosProspecto } from 'app/models/FiltrosProspecto';
import moment from 'moment';
import { UtilProspecto } from 'app/models/UtilProspeccion';
import { environment } from 'environments/environment';
@Component({
  selector: 'app-nueva-respuesta-prospecto',
  templateUrl: './nueva-respuesta-prospecto.component.html',
  styleUrls: ['./nueva-respuesta-prospecto.component.scss'],
  providers: [DatePipe, DecimalPipe, MessagesTitles, MessagesGeneral, MessagesDates, MessagesStatus,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class NuevaRespuestaProspectoComponent implements OnInit, OnDestroy {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_Prospectos=environment.LABEL_PROSPECTOS;
  Label_Prospecto=environment.LABEL_PROSPECTO;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  @Output() cerrarEvaluacionProspecto: EventEmitter<boolean> = new EventEmitter();
  @Output() refreshProspecto: EventEmitter<boolean> = new EventEmitter();
  @Input() prospecto: ProspectoCab;
  DTOFiltrosProspecto: FiltrosProspecto = new FiltrosProspecto();
  formRespuesta: FormGroup;
  tituloFormRespuesta: string;
  usuarioProspecto: string;
  usuarioRespuesta: string;
  html: string;
  isChecked: boolean;
  loading: boolean;
  arrDataCorreo: any;
  respuesta: ProspectoCab = new ProspectoCab();
  usuario: any;
  observacionesOriginales: string;
  observacionesArray: string[] = [];
  montoPropuestaActual: number = 0;
  observacionesArrayFormat: ObservacionesRespuestaFormat;
  observacionesFinal: any[] = [];
  subLista: Subscription[] = [];
  subRiesgo: Subscription = new Subscription();
  subRespProspecto: Subscription = new Subscription();
  lineaMonedaSimbolo: string;
  colorLineaAdmitida: string;
  colorLineaUtilizada: string;
  colorLineaDisponible: string;
  readonly COLOR_MONTO_POSITIVO = '#23af23';
  readonly COLOR_MONTO_CERO = '#1da0ec';
  readonly COLOR_MONTO_NEGATIVO = '#ff5454';

  constructor(
    private prospectoService: ProspectosService,
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe
  ) {
    this.colorLineaAdmitida = this.COLOR_MONTO_CERO;
    this.colorLineaUtilizada = this.COLOR_MONTO_CERO;
    this.colorLineaDisponible = this.COLOR_MONTO_CERO;

    this.formRespuesta = new FormGroup({
      respObservaciones: new FormControl(''),
      Monto_Comercial: new FormControl(''),
      Monto_Riesgo_Inicial: new FormControl('', [Validators.required]),
      Monto_Riesgo_Ejecutado: new FormControl(''),
      Monto_Riesgo_Disponible: new FormControl(''),
      Monto_Riesgo_Finalizado: new FormControl(''),
      Sum_VNPP: new FormControl('')
    });
    this.usuario = JSON.parse(sessionStorage.getItem('UserActive'));
    this.usuarioRespuesta = this.usuario.Nombre;
    this.DTOFiltrosProspecto.FechaIni = this.datePipe.transform(moment().add(-30, 'day'), 'yyyy-MM-dd');
    this.DTOFiltrosProspecto.FechaFin = this.datePipe.transform(moment(), 'yyyy-MM-dd');
  }

  ngOnInit() {
    console.log("Prueba prospecto",this.prospecto);
    this.obtenerProspecto();
    this.tituloFormRespuesta = this.prospecto.edit ? 'Reevaluar '+this.Label_Prospecto+'N° '.concat(this.prospecto.idProspecto.toString()) : this.Label_Prospecto+' N° '.concat(this.prospecto.idProspecto.toString());
    if (this.prospecto.idPropuestaOperacion != null) {
      this.tituloFormRespuesta = this.tituloFormRespuesta.concat(' asociado a Propuesta de Operación N° ', this.prospecto.idPropuestaOperacion.toString());
    }

    if (this.prospecto.Observaciones_Riesgo) {
      if (this.prospecto.Observaciones_Riesgo.includes("|")) {
        this.observacionesArray = this.prospecto.Observaciones_Riesgo.split("|");
      } else {
        this.observacionesArray[0] = this.prospecto.Observaciones_Riesgo;
      }
      this.observacionesArray.forEach((item, i) => {
        let cadenaFecha = this.observacionesArray[i].split(",")[0]; // Cadena de fecha hasta la coma (,)
        let cadenaParcial = this.observacionesArray[i].slice(this.observacionesArray[i].indexOf(',')); // Cadena sin la fecha        
        this.observacionesArrayFormat = new ObservacionesRespuestaFormat();
        this.observacionesArrayFormat.fecha = cadenaFecha.slice(this.observacionesArray[i].indexOf(" ")).trim(); // Cadena con solo fecha, sin espacios
        this.observacionesArrayFormat.usuario = cadenaParcial.substring(9, cadenaParcial.indexOf(":")).trim(); // Cadena con solo nombre de usuario, sin espacios
        this.observacionesArrayFormat.observacion = cadenaParcial.slice(cadenaParcial.indexOf(":") + 2).trim(); // Cadena con solo observaciones, sin espacios
        this.observacionesFinal.push(this.observacionesArrayFormat);
      });
    }
  }

  ngOnDestroy() {
    this.subLista.forEach(sub => { sub.unsubscribe(); });
  }

  obtenerProspecto() {
    this.prospecto.Moneda_Dsc = this.prospecto.Moneda_Dsc.toUpperCase();
    this.formatMoneda(this.prospecto.Moneda);
    this.formatMontos(this.prospecto);
    this.prospecto.vnppTotal = Number(this.prospecto.vnppTotal);

    if (this.prospecto.vnppTotal > 0 && this.prospecto.propuesta && this.prospecto.Estado_Prospecto_Det != 'F') {
      let montoTemp: number | string = 0;
      montoTemp = Number(this.prospecto.Monto_Riesgo_Inicial) - Number(this.prospecto.vnppTotal);
      montoTemp = this.decimalPipe.transform(montoTemp, '1.2-2');

      this.formRespuesta.patchValue({
        Monto_Comercial: this.decimalPipe.transform(this.prospecto.Monto_Comercial, '1.2-2'),
        Monto_Riesgo_Inicial: this.decimalPipe.transform(this.prospecto.Monto_Riesgo_Inicial, '1.2-2'),
        Monto_Riesgo_Ejecutado: this.decimalPipe.transform(this.prospecto.Monto_Riesgo_Ejecutado, '1.2-2'),
        Monto_Riesgo_Disponible: montoTemp,
        Monto_Riesgo_Finalizado: this.decimalPipe.transform(this.prospecto.Monto_Riesgo_Finalizado, '1.2-2'),
        Sum_VNPP: this.decimalPipe.transform(this.prospecto.vnppTotal, '1.2-2')
      });

    } else {
      this.actualizarDataProspecto();
    }
  }

  formatMoneda(moneda: string) {
    if (moneda == `${this.Label_id_soles}`) {
      this.lineaMonedaSimbolo = 'S/ ';
    } else if (moneda == `${this.Label_id_dolares}`) {
      this.lineaMonedaSimbolo = '$ ';
    } else {
      this.lineaMonedaSimbolo = '';
    }
  }

  formatMontos(prospecto: ProspectoCab) {
    prospecto.LineaAdmitida = prospecto.LineaAdmitida != null ? prospecto.LineaAdmitida : null;
    prospecto.LineaUtilizada = prospecto.LineaUtilizada != null ? prospecto.LineaUtilizada : null;
    prospecto.LineaDisponible = prospecto.LineaDisponible != null ? prospecto.LineaDisponible : null;
    this.colorLineaAdmitida = this.setColorMontosLineas(prospecto.LineaAdmitida);
    this.colorLineaUtilizada = this.setColorMontosLineas(prospecto.LineaUtilizada);
    this.colorLineaDisponible = this.setColorMontosLineas(prospecto.LineaDisponible);
  }

  setColorMontosLineas(monto: number): string {
    if (monto > 0.00) {
      return this.COLOR_MONTO_POSITIVO;
    } else if (monto == 0.00) {
      return this.COLOR_MONTO_CERO;
    } else {
      return this.COLOR_MONTO_NEGATIVO;
    }
  }

  actualizarDataProspecto() {
    Swal.fire({
      title: 'Espere',
      text: 'Obteniendo información actualizada',
      type: 'info',
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();

    this.DTOFiltrosProspecto.FechaIni = this.datePipe.transform(this.DTOFiltrosProspecto.FechaIni, 'yyyy-MM-dd');
    this.DTOFiltrosProspecto.FechaFin = this.datePipe.transform(this.DTOFiltrosProspecto.FechaFin, 'yyyy-MM-dd');
    this.DTOFiltrosProspecto.Version = 2;
    this.subRiesgo = this.prospectoService.obtenerProspectoCab(this.DTOFiltrosProspecto).subscribe(
      (resp: ProspectoCab[]) => {
        Swal.close();
        let response = resp.filter(p => p.idProspecto == this.prospecto.idProspecto && p.FlagAsignado);
        response[0] = this.prospecto;
        this.formRespuesta.patchValue({
          Monto_Comercial: this.decimalPipe.transform(this.prospecto.Monto_Comercial, '1.2-2'),
          Monto_Riesgo_Inicial: this.decimalPipe.transform(this.prospecto.Monto_Riesgo_Inicial, '1.2-2'),
          Monto_Riesgo_Disponible: this.decimalPipe.transform(this.prospecto.Monto_Riesgo_Disponible, '1.2-2'),
          Monto_Riesgo_Ejecutado: this.decimalPipe.transform(this.prospecto.Monto_Riesgo_Ejecutado, '1.2-2'),
          Monto_Riesgo_Finalizado: this.decimalPipe.transform(this.prospecto.Monto_Riesgo_Finalizado, '1.2-2'),
          Sum_VNPP: this.decimalPipe.transform(this.prospecto.Sum_VNPP, '1.2-2')
        });
      },
      (err: HttpErrorResponse) => {
        Swal.fire({
          title: "Ha ocurrido un error",
          text: err.error.error,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );

    this.subLista.push(this.subRiesgo);
  }

  editarMontoRiesgo() {
    if (this.prospecto.vnppTotal == 0) {
      Swal.fire({
        title: 'Atención',
        text: 'Revisar la suma del VNPP (valor actual: 0).',
        type: 'info',
        allowOutsideClick: false,
        heightAuto: false
      });
    } else {
      Swal.fire({
        title: 'Atención',
        text: 'Confirmar la asignación del monto para esta propuesta de operación.',
        type: 'info',
        showCancelButton: true,
        cancelButtonText: 'No, cancelar',
        showConfirmButton: true,
        confirmButtonText: 'Si, continuar',
        allowOutsideClick: false,
        reverseButtons: true,
        heightAuto: false
      }).then((result) => {
        if (result.value) {

          Swal.fire({
            title: 'Espere',
            text: 'Guardando Información',
            type: 'info',
            allowOutsideClick: false,
            heightAuto: false
          });
          Swal.showLoading();

          this.prospecto.Monto_Riesgo_Ejecutado = this.formRespuesta.get('Monto_Riesgo_Ejecutado').value;
          this.prospecto.Monto_Riesgo_Disponible = this.formRespuesta.get('Monto_Riesgo_Disponible').value;
          let disponible: string = this.formRespuesta.get('Monto_Riesgo_Disponible').value;
          disponible = disponible.replace(',', '');
          this.prospecto.Monto_Riesgo_Disponible = disponible;
          this.prospecto.Monto_Riesgo_Finalizado = this.formRespuesta.get('Monto_Riesgo_Finalizado').value;

          let opcionCambio = UtilProspecto.VALOR_DEFECTO;
          opcionCambio = (!this.prospecto.FlagAsignado) ? UtilProspecto.PRIMER_USO : UtilProspecto.MULTIPLE_USO;
          let bodyMontoRiesgo = {
            prospecto: this.prospecto,
            opcion: opcionCambio,
            Alta_Usuario_Riesgo: this.usuario.Usuario
          };

          this.prospectoService.editarMontoRiesgoPropuesta(bodyMontoRiesgo).subscribe(
            res => {
              Swal.fire({
                title: 'Éxito',
                text: "¡Se guardaron los cambios de manera correcta!",
                type: "success",
                allowOutsideClick: false,
                heightAuto: false
              });

              this.metCerrarEvaluacionProspecto();
              this.refreshProspecto.emit();
            },
            err => {
              Swal.fire({
                title: 'Error',
                text: "Hubo un error a la hora de actualizar el monto del "+this.Label_Prospecto.toLowerCase()+". Contacte con soporte.",
                type: "error",
                allowOutsideClick: false,
                heightAuto: false
              });
              this.metCerrarEvaluacionProspecto();
            }
          );
        }
      });
    }
  }

  montoInicialValido() {
    let montoReadonly: boolean = false;
    montoReadonly = (!this.prospecto.edit && this.prospecto.Estado != 'P') || (this.prospecto.propuesta && this.prospecto.vnppTotal == 0);
    return montoReadonly;
  }

  montoDisponibleValido() {
    let montoReadonly: boolean = false;
    montoReadonly = !this.prospecto.propuesta || this.prospecto.vnppTotal == 0 || this.prospecto.Estado_Prospecto_Det == 'F';
    return montoReadonly;
  }

  metCerrarEvaluacionProspecto() {
    this.cerrarEvaluacionProspecto.emit();
  }

  armarBodyRespuesta(id: number, observaciones: string, edit: boolean) {
    this.respuesta.idProspecto = id;
    this.respuesta.idProspectoDet = (this.respuesta.Estado == 'F') ? this.prospecto.idProspectoDet : null;
    this.respuesta.Observaciones_Riesgo = edit ? this.prospecto.Observaciones_Riesgo.concat('$$', observaciones) : '$$'.concat(observaciones);
    this.respuesta.Alta_Usuario_Riesgo = this.usuario.Usuario;
    this.respuesta.Nombre_Usuario_Riesgo = this.usuarioRespuesta;
    this.respuesta.Correo_Usuario_Riesgo = edit ? this.prospecto.Correo_Usuario_Riesgo : this.usuario.Email;
    this.respuesta.Correo_Comercial = this.prospecto.Correo_Comercial;
    this.respuesta.Fecha_Respuesta = edit ? this.prospecto.Fecha_Respuesta : null;
    this.respuesta.Fecha_Actualizacion = (this.montosModificados(this.prospecto, this.formRespuesta)) ? this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss') : null;
    this.respuesta.Monto_Riesgo_Disponible = this.formRespuesta.get('Monto_Riesgo_Disponible').value;
    this.respuesta.Monto_Riesgo_Inicial = this.formRespuesta.get('Monto_Riesgo_Inicial').value;
    this.respuesta.FlagAsignado = (this.prospecto.FlagAsignado) ? this.prospecto.FlagAsignado : null;
    this.respuesta.idPropuestaOperacion = (this.prospecto.idPropuestaOperacion) ? this.prospecto.idPropuestaOperacion : null;
  }

  montosModificados(prospectoBD: ProspectoCab, formProspecto: FormGroup) {
    let modificado: boolean = false;
    if (prospectoBD.Monto_Riesgo_Inicial != formProspecto.get('Monto_Riesgo_Inicial').value ||
      prospectoBD.Monto_Riesgo_Disponible != formProspecto.get('Monto_Riesgo_Disponible').value ||
      prospectoBD.Monto_Riesgo_Ejecutado != formProspecto.get('Monto_Riesgo_Ejecutado').value ||
      prospectoBD.Monto_Riesgo_Finalizado != formProspecto.get('Monto_Riesgo_Finalizado').value) {
      modificado = true;
    }
    return modificado;
  }

  aceptarProspecto(id: number, edit: boolean) {
    Swal.fire({
      text: !edit ? "¿Aprobar "+this.Label_Prospecto+"?" : "¿Reevaluar "+this.Label_Prospecto+"?",
      type: "question",
      showCancelButton: true,
      cancelButtonText: 'No, cancelar',
      showConfirmButton: true,
      confirmButtonText: 'Si, Aceptar '+this.Label_Prospecto.toLowerCase(),
      allowOutsideClick: false,
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: 'Espere',
          text: 'Guardando Información...',
          type: 'info',
          allowOutsideClick: false,
          heightAuto: false
        });
        Swal.showLoading();
        this.armarBodyRespuesta(id, this.formRespuesta.get('respObservaciones').value, edit);

        if (edit) {
          this.subRespProspecto = this.prospectoService.reeevaluarProspecto(this.respuesta).subscribe(
            resP => {

              Swal.fire({
                title: this.Label_Prospecto+' Reevaluado',
                text: "¡Se generó la respuesta de manera exitosa!",
                type: "success",
                allowOutsideClick: false,
                heightAuto: false
              });

              this.metCerrarEvaluacionProspecto();

            },
            errP => {

              Swal.fire({
                title: 'Error',
                text: "Lo sentimos, hubo un error a la hora de aceptar el "+this.Label_Prospecto.toLowerCase()+". Contacte con soporte.",
                type: "error",
                allowOutsideClick: false,
                heightAuto: false
              });

              this.metCerrarEvaluacionProspecto();

            }
          );
        } else {
          this.subRespProspecto = this.prospectoService.evaluarProspecto(this.respuesta).subscribe(
            resP => {

              Swal.fire({
                title: this.Label_Prospecto+' Aceptado',
                text: "¡Se generó la respuesta de manera exitosa!",
                type: "success",
                allowOutsideClick: false,
                heightAuto: false
              });

              this.metCerrarEvaluacionProspecto();

            },
            errP => {

              Swal.fire({
                title: 'Error',
                text: "Lo sentimos, hubo un error a la hora de reevaluar el "+this.Label_Prospecto.toLowerCase()+". Contacte con soporte.",
                type: "error",
                allowOutsideClick: false,
                heightAuto: false
              });

              this.metCerrarEvaluacionProspecto();
            }
          );
        }

        this.subLista.push(this.subRespProspecto);
      } else {
        if (this.formRespuesta.get('respObservaciones').value == 'No hay observaciones') {
          this.formRespuesta.get('respObservaciones').setValue('');
        }
      }
    });
  }

  rechazarProspecto(id: number, edit: boolean) {
    Swal.fire({
      text: !edit ? "¿Rechazar "+this.Label_Prospecto+"?" : "¿Reevaluar "+this.Label_Prospecto+"?",
      type: "question",
      showCancelButton: true,
      cancelButtonText: 'No, cancelar',
      showConfirmButton: true,
      confirmButtonText: 'Si, Rechazar '+this.Label_Prospecto.toLowerCase()+'.',
      allowOutsideClick: false,
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: 'Espere',
          text: 'Guardando Información...',
          type: 'info',
          allowOutsideClick: false
        });
        Swal.showLoading();
        this.armarBodyRespuesta(id, this.formRespuesta.get('respObservaciones').value, edit);

        if (edit) {
          this.subRespProspecto = this.prospectoService.reeevaluarProspecto(this.respuesta).subscribe(
            () => {
              this.showSwalAfterResponse(this.Label_Prospecto+' Reevaluado', '¡Se generó la respuesta de manera exitosa!');
            },
            () => {
              this.showSwalAfterResponse('Error', 'Lo sentimos, hubo un error a la hora de reevaluar el '+this.Label_Prospecto.toLowerCase()+'. Contacte con soporte.');
            }
          );
        } else {
          this.subRespProspecto = this.prospectoService.evaluarProspecto(this.respuesta).subscribe(
            () => {

              Swal.fire({
                title: this.Label_Prospecto+' Rechazado',
                text: "¡Se generó la respuesta de manera exitosa!",
                type: "success",
                allowOutsideClick: false,
                heightAuto: false
              });

              this.metCerrarEvaluacionProspecto();

            },
            () => {

              Swal.fire({
                title: 'Error',
                text: "Lo sentimos, hubo un error a la hora de rechazar el "+this.Label_Prospecto.toLowerCase()+". Contacte con soporte.",
                type: "error",
                allowOutsideClick: false,
                heightAuto: false
              });

              this.metCerrarEvaluacionProspecto();

            }
          );
        }

        this.subLista.push(this.subRespProspecto);
      } else {
        if (this.formRespuesta.get('respObservaciones').value == 'No hay observaciones') {
          this.formRespuesta.get('respObservaciones').setValue('');
        }
      }
    });
  }

  finalizarProspecto(id: number) {
    Swal.fire({
      text: "¿Finalizar "+this.Label_Prospecto+"?",
      type: "question",
      showCancelButton: true,
      cancelButtonText: 'No, cancelar',
      showConfirmButton: true,
      confirmButtonText: 'Si, Finalizar '+this.Label_Prospecto.toLowerCase()+'.',
      allowOutsideClick: false,
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: 'Espere',
          text: 'Guardando Información...',
          type: 'info',
          allowOutsideClick: false,
          heightAuto: false
        });
        Swal.showLoading();
        this.armarBodyRespuesta(id, this.formRespuesta.get('respObservaciones').value, true);


        this.subRespProspecto = this.prospectoService.reeevaluarProspecto(this.respuesta).subscribe(
          () => {
            this.showSwalAfterResponse(this.Label_Prospecto+' Reevaluado', '¡Se generó la respuesta de manera exitosa!');
          },
          () => {

            Swal.fire({
              title: 'Error',
              text: "Lo sentimos, hubo un error a la hora de finalizar el "+this.Label_Prospecto.toLowerCase()+". Contacte con soporte.",
              type: "error",
              allowOutsideClick: false,
              heightAuto: false
            });

            this.metCerrarEvaluacionProspecto();

          }
        );

        this.subLista.push(this.subRespProspecto);
      }
    });
  }

  evaluarProspecto(id: number, tipoOperacion: string, edit?: boolean) {
    let observaciones: string = this.formRespuesta.get('respObservaciones').value;

    if (tipoOperacion == 'aceptar') {
      if (observaciones.trim() == '') {
        this.respuesta.Estado = 'A';
        this.formRespuesta.get('respObservaciones').setValue('No hay observaciones');
      } else {
        this.respuesta.Estado = 'AC';
      }
      this.aceptarProspecto(id, edit);
    } else if (tipoOperacion == 'rechazar') {
      this.respuesta.Estado = 'R';
      if (observaciones.trim() == '') {
        this.formRespuesta.get('respObservaciones').setValue('No hay observaciones');
      }
      this.rechazarProspecto(id, edit);
    } else {
      this.respuesta.Estado = 'F';
      if (observaciones.trim() == '') {
        Swal.fire({
          title: 'Atención',
          text: "¡Debes escribir una observación para finalizar el "+this.Label_Prospecto.toLowerCase()+"!",
          type: "info",
          allowOutsideClick: false,
          heightAuto: false
        });
        return;
      } else {
        this.finalizarProspecto(id);
      }
    }
  }

  hideBtnFinalizarProspecto(prospecto: any) {
    return prospecto.propuesta || !prospecto.edit || prospecto.Estado_Prospecto_Det == 'F' || prospecto.Estado == 'P';
  }

  hideBtnEvaluarProspecto(prospecto: any) {
    return prospecto.Estado != 'P' && !prospecto.edit;
  }

  showSwalAfterResponse(title: string, text: string) {
    Swal.fire({
      title: title,
      text: text,
      type: "success",
      allowOutsideClick: false,
      heightAuto: false
    });

    this.metCerrarEvaluacionProspecto();
  }
}